import { Card, Tag } from 'antd';
import { Link } from 'react-router-dom';
import { isDefined } from 'app/helpers/objectHelper';
import { AgentListItem } from "app/pages/AgentSearch/modules/AgentItemsList/state";

export interface AgentItemProps {
    agent: AgentListItem;
}

const AgentItem = (props: AgentItemProps) => (
    <Card
        id={props.agent.id}
        title={
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Link to={`/agents/rates?id=${encodeURIComponent(props.agent.id)}&name=${encodeURIComponent(props.agent.name)}`}>
                    {props.agent.name}
                </Link>
                <Tag color={props.agent.status.cssClass}>{props.agent.status.name}</Tag>
            </div>
        }
        extra={<div>{props.agent.classification || 'Unknown'}</div>}
        style={{ width: '100%', marginBottom: '16px' }}
    >
        <div>
            {getCountry(props.agent)}
            {getOwner(props.agent)}
        </div>
    </Card>
);

function getOwner(agent: AgentListItem) {
    if (agent.ownerFullName === undefined || agent.ownerFullName === undefined) return <></>;
    return <p>Owner: {agent.ownerFullName}</p>;
}

function getCountry(agent: AgentListItem) {
    if (!isDefined(agent.countryName)) return <></>;

    return agent.countryIsoCode !== undefined ? (
        <p>
            <i className={agent.countryIsoCode.toLowerCase() + ' flag'}></i> {agent.countryName}
        </p>
    ) : (
        <p>{agent.countryName}</p>
    );
}

export default AgentItem;
